<template>
  <widget>
    <template v-slot:title>
      {{ title }}
    </template>
    <template v-slot:content>
      <v-simple-table>
        <thead>
          <tr>
            <th>Amount</th>
            <th>Stage</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, i) in salesPipeline.items"
            :key="i"
          >
            <td>{{ item.amount }}</td>
            <td>{{ item.stage }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </template>
  </widget>
</template>

<script>

import store from '@/store'
import Widget from './Widget'

export default {
  name: 'SalesPipeline',
  components: {Widget},
  data () {
    return {
      title: 'Sales Pipeline',
      pipelineFields: ['amount', 'stage']
    }
  },
  computed: {
    salesPipeline () {
      return store.state.dashboard.salesPipeline
    }
  },
  beforeMount () {
    store.dispatch('dashboard/fetchSalesPipeline')
  }
}
</script>

<style scoped>

</style>
